import { render } from "./CropTest.vue?vue&type=template&id=707a4b50"
import script from "./CropTest.vue?vue&type=script&lang=js"
export * from "./CropTest.vue?vue&type=script&lang=js"

import "./CropTest.vue?vue&type=style&index=0&id=707a4b50&lang=css"
script.render = render

export default script